import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showEventPopup, setShowEventPopup] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem('eventPopupSeen');
    if (!hasSeenPopup) {
      setTimeout(() => {
        setShowEventPopup(true);
      }, 1000);
    }
  }, []);

  const closePopup = () => {
    setShowEventPopup(false);
    sessionStorage.setItem('eventPopupSeen', 'true');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 to-purple-50">
      {/* Event Popup */}
      {showEventPopup && (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
            <button
              onClick={closePopup}
              className="absolute top-4 right-4 w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors cursor-pointer z-10"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>

            <div className="p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="inline-block bg-gradient-to-r from-violet-500 to-purple-500 text-white px-6 py-2 rounded-full font-bold text-sm mb-4">
                  🎉 신규 원장님 특별이벤트
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  학원마케팅 진단 + 포스팅 2회 패키지
                </h3>
                <div className="text-3xl md:text-4xl font-bold text-violet-600 mb-3">
                  단 5만원!
                </div>
                <p className="text-gray-600">
                  (상담 완료한 원장님 전용 특별 프로모션)
                </p>
              </div>

              <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-6 mb-6">
                <p className="text-gray-700 leading-relaxed text-center">
                  학원마케팅이 꼭 필요하지만<br />
                  <strong>"어디부터 손봐야 할지 모르겠다"</strong>,<br />
                  <strong>"우리 학원은 지금 어떤 상태인지 궁금하다"</strong><br />
                  하셨던 원장님들을 위해 준비한 실전형 이벤트 패키지입니다.
                </p>
              </div>

              <div className="space-y-4 mb-6">
                <div className="bg-white rounded-xl p-6 shadow-md border-2 border-violet-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-violet-500 to-purple-500 rounded-full flex items-center justify-center">
                      <i className="ri-search-line text-white"></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">학원 전용 마케팅 진단</h4>
                  </div>
                  <div className="space-y-2 text-sm">
                    {[
                      "네이버 검색 노출 점검",
                      "경쟁 학원 키워드 분석",
                      "학부모가 검색하는 실제 키워드 체크",
                      "학원의 현재 온라인 브랜딩 진단"
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <i className="ri-check-line text-violet-500"></i>
                        <span className="text-gray-700">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md border-2 border-violet-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-violet-500 to-purple-500 rounded-full flex items-center justify-center">
                      <i className="ri-article-line text-white"></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">블로그 포스팅 2회 제작</h4>
                  </div>
                  <div className="space-y-2 text-sm">
                    {[
                      "학부모 검색 기준으로 기획",
                      "원장님 학원의 강점·차별점 집중 노출",
                      "썸네일 포함 최적화 포스팅",
                      "상담 유도형 구조 적용"
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <i className="ri-check-line text-violet-500"></i>
                        <span className="text-gray-700">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-violet-500 to-purple-500 rounded-xl p-6 text-white text-center mb-6">
                <div className="mb-4">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <i className="ri-gift-line text-xl"></i>
                    <h4 className="text-lg font-bold">대상</h4>
                  </div>
                  <p className="text-sm">
                    <strong>상담 완료한 원장님 한정</strong>
                  </p>
                  <p className="text-xs opacity-90 mt-1">
                    본 이벤트는 이미 상담을 진행하신 원장님들께<br />
                    감사한 마음을 담아 드리는 특별 혜택입니다.
                  </p>
                </div>

                <div className="border-t border-white/30 pt-4">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <i className="ri-time-line text-xl"></i>
                    <h4 className="text-lg font-bold">진행 기간</h4>
                  </div>
                  <p className="text-lg font-bold">
                    2025년 12월 1일 ~ 12월 31일
                  </p>
                </div>
              </div>

              <div className="text-center">
                <a
                  href="#contact"
                  onClick={closePopup}
                  className="inline-block bg-gradient-to-r from-violet-600 to-purple-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-violet-700 hover:to-purple-700 transition-all cursor-pointer whitespace-nowrap shadow-lg"
                >
                  이벤트 신청하기
                </a>
                <p className="text-xs text-gray-500 mt-3">
                  * 상담 완료 후 이벤트 신청이 가능합니다
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-violet-600" style={{ fontFamily: '"Pacifico", serif' }}>
                블룸업마케팅
              </h1>
            </div>

            <nav className="hidden md:flex space-x-8">
              <a href="#services" className="text-gray-700 hover:text-violet-600 transition-colors cursor-pointer whitespace-nowrap">서비스</a>
              <a href="#trust" className="text-gray-700 hover:text-violet-600 transition-colors cursor-pointer whitespace-nowrap">신뢰성</a>
              <a href="#about" className="text-gray-700 hover:text-violet-600 transition-colors cursor-pointer whitespace-nowrap">회사소개</a>
              <a href="#contact" className="text-gray-700 hover:text-violet-600 transition-colors cursor-pointer whitespace-nowrap">상담문의</a>
            </nav>

            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-violet-600 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-menu-line text-xl"></i>
              </div>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="#services" className="block px-3 py-2 text-gray-700 hover:text-violet-600 cursor-pointer">서비스</a>
              <a href="#trust" className="block px-3 py-2 text-gray-700 hover:text-violet-600 cursor-pointer">신뢰성</a>
              <a href="#about" className="block px-3 py-2 text-gray-700 hover:text-violet-600 cursor-pointer">회사소개</a>
              <a href="#contact" className="block px-3 py-2 text-gray-700 hover:text-violet-600 cursor-pointer">상담문의</a>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/74657ebd044a367404b252d7c4e2fb5b.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-violet-900/70 to-purple-900/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              학원 마케팅의
              <br />
              <span className="text-violet-300">새로운 기준</span>
            </h2>
            <p className="text-xl md:text-2xl text-violet-100 mb-8 leading-relaxed">
              마케팅 전문가가 만드는
              <br />
              학원 전문 블로그 & 인스타그램 마케팅
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#contact"
                className="bg-violet-500 hover:bg-violet-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                무료 상담 받기
              </a>
              <a
                href="#services"
                className="border-2 border-white text-white hover:bg-white hover:text-violet-600 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                서비스 보기
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Trust & Reliability Section */}
      <section id="trust" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-violet-600">더 이상 사기 걱정 없이</span> 안심하고 맡기세요
            </h3>
            <p className="text-xl text-gray-600">동탄·오산·경기도 지역 학원 전문, 투명하고 정직한 마케팅</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-violet-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">경기도 지역 전문</h4>
              <p className="text-gray-600 text-center leading-relaxed">
                동탄, 오산을 비롯한 경기도 지역 학원들의 특성을 정확히 이해하고 있습니다.
                지역 학부모들의 검색 패턴과 선호도를 반영한 맞춤형 마케팅을 제공합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-violet-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">투명한 계약과 정직한 소통</h4>
              <p className="text-gray-600 text-center leading-relaxed">
                모든 서비스는 명확한 계약서를 통해 진행되며, 작업 과정과 결과를 투명하게 공유합니다.
                숨겨진 비용이나 불분명한 약속은 절대 없습니다.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-violet-500 to-purple-500 rounded-2xl p-8 md:p-12 text-white">
            <div className="max-w-4xl mx-auto">
              <h4 className="text-2xl md:text-3xl font-bold mb-6 text-center">
                블룸업마케팅은 믿을 수 있는 업체입니다
              </h4>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                  <i className="ri-building-line text-3xl mb-3"></i>
                  <h5 className="font-bold mb-2">정식 사업자</h5>
                  <p className="text-sm opacity-90">사업자번호 102-20-08696</p>
                  <p className="text-xs opacity-75 mt-2">국세청 등록 정식 사업자</p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                  <i className="ri-user-heart-line text-3xl mb-3"></i>
                  <h5 className="font-bold mb-2">실명 공개</h5>
                  <p className="text-sm opacity-90">대표 김초롱</p>
                  <p className="text-xs opacity-75 mt-2">책임감 있는 실명 운영</p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                  <i className="ri-phone-line text-3xl mb-3"></i>
                  <h5 className="font-bold mb-2">직접 소통</h5>
                  <p className="text-sm opacity-90">010.4963.0538</p>
                  <p className="text-xs opacity-75 mt-2">언제든 연락 가능</p>
                </div>
              </div>

              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 text-center">
                <p className="text-lg leading-relaxed mb-4">
                  <strong>"학원 마케팅 사기 때문에 고민하셨나요?"</strong>
                </p>
                <p className="leading-relaxed">
                  블룸업마케팅은 정직하고 투명한 서비스로 원장님들의 신뢰를 얻고 있습니다.<br />
                  계약서 작성, 작업 과정 공유, 결과 리포트 제공까지 모든 과정이 투명합니다.<br />
                  <span className="font-bold text-yellow-300">더 이상 걱정하지 마시고, 안심하고 맡겨주세요.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why BloomUp Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              왜 <span className="text-violet-600">블룸업</span>을 선택해야 할까요?
            </h3>
            <p className="text-xl text-gray-600">전문가가 만드는 차별화된 마케팅</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-violet-50 to-purple-50 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-violet-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-graduation-cap-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">학원 전문</h4>
              <p className="text-gray-600">학원 업계만을 위한 특화된 마케팅 전략과 노하우</p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-violet-50 to-purple-50 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-violet-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">신뢰할 수 있는</h4>
              <p className="text-gray-600">투명한 소통과 확실한 결과로 고객의 신뢰를 얻는 마케팅</p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-violet-500 to-purple-500 rounded-2xl p-8 md:p-12 text-center text-white">
            <h4 className="text-2xl md:text-3xl font-bold mb-4">
              부담 없이 상담받아보세요
            </h4>
            <p className="text-lg md:text-xl mb-8 opacity-90">
              학원 마케팅에 대한 고민, 언제든 편하게 문의해주세요
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="flex items-center justify-center gap-2 text-lg">
                <i className="ri-phone-line"></i>
                <span>010.4963.0538</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-lg">
                <i className="ri-mail-line"></i>
                <span>bloomup.kim@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 학원마케팅 필요한 이유 Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900">
                학원 마케팅이 필요한 이유
              </h3>
              <i className="ri-volume-up-line text-3xl text-violet-600"></i>
            </div>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 md:p-12 mb-12">
              <h4 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">
                <strong>학원 운영, 이제 혼자 하지 마세요.</strong>
              </h4>
              <div className="text-center mb-8">
                <p className="text-xl md:text-2xl font-bold text-violet-600 mb-4">
                  블룸업마케팅이 '상담이 들어오는 학원'으로 만들어드립니다.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  학부모가 학원을 선택할 때 가장 먼저 보는 건<br />
                  <span className="font-bold text-violet-600">노출·브랜딩·신뢰감</span>입니다.<br />
                  우리는 이 3가지를 전문적으로 설계하는<br />
                  학원 전문 마케팅 팀입니다.
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-violet-100">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-8 h-8 bg-violet-500 rounded-full flex items-center justify-center">
                    <i className="ri-fire-line text-white text-lg"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">블룸업이 해드립니다</h4>
                </div>
                <div className="space-y-3">
                  {[
                    "네이버 상위노출 블로그 제작",
                    "학부모 맞춤형 신뢰 콘텐츠",
                    "학원 철학·강점 브랜딩",
                    "지역 타겟형 전략 설계",
                    "학원 시스템 소개 콘텐츠",
                    "상담 전환형 CTA 구조",
                    "후기/성과 중심 콘텐츠 제작",
                    "꾸준한 포스팅으로 브랜드력 강화",
                    "인스타/지도/검색 최적화",
                    "원장님 시간 완전 절약 가능"
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500 text-lg"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-violet-100">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-8 h-8 bg-violet-500 rounded-full flex items-center justify-center">
                    <i className="ri-star-line text-white text-lg"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">블룸업을 선택해야 하는 이유</h4>
                </div>
                <div className="bg-gradient-to-r from-violet-100 to-purple-100 p-6 rounded-xl mb-6">
                  <p className="text-gray-800 font-medium text-center leading-relaxed">
                    "잘하는 학원을 부모님은 모릅니다.<br />
                    잘 보이는 학원을 선택할 뿐입니다."<br />
                    <span className="text-violet-600 font-bold">블룸업은 원장님의 학원을<br />보이게 만드는 팀입니다.</span>
                  </p>
                </div>

                <div className="mb-6">
                  <div className="flex items-center gap-2 mb-4">
                    <i className="ri-pushpin-line text-violet-500"></i>
                    <h5 className="font-bold text-gray-900">이런 학원이라면 필수입니다</h5>
                  </div>
                  <div className="space-y-2">
                    {[
                      "신규 문의가 줄었다",
                      "경쟁 학원만 보인다",
                      "운영 때문에 홍보할 시간이 없다",
                      "콘텐츠를 꾸준히 만들 자신이 없다",
                      "학원 강점을 정리하지 못했다"
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <i className="ri-check-line text-violet-500"></i>
                        <span className="text-gray-700 text-sm">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-r from-violet-500 to-purple-500 text-white p-4 rounded-xl text-center">
                  <i className="ri-arrow-right-line text-xl mb-2"></i>
                  <p className="font-bold">블룸업마케팅이 '처음부터 끝까지' 해결해드립니다.</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-violet-500 to-purple-500 rounded-2xl p-8 text-white text-center">
              <div className="flex items-center justify-center gap-2 mb-4">
                <i className="ri-seedling-line text-2xl"></i>
                <h4 className="text-2xl font-bold">지금 바로 상담하세요</h4>
              </div>
              <p className="text-lg mb-6 opacity-90 leading-relaxed">
                학부모가 선택하는 학원,<br />
                브랜드가 살아있는 학원,<br />
                꾸준히 상담이 들어오는 학원.
              </p>
              <p className="text-xl font-bold mb-8">
                그 시작은 <span className="text-yellow-300">블룸업마케팅</span>입니다.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="#contact"
                  className="bg-white text-violet-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  무료 상담 신청하기
                </a>
                <a
                  href="https://blog.naver.com/bloomupkim/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-white text-white hover:bg-white hover:text-violet-600 px-8 py-3 rounded-full font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-external-link-line"></i>
                  네이버 블로그 보기
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 bg-gradient-to-br from-violet-50 via-white to-purple-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">블룸업마케팅 패키지 가격</h2>
            <p className="text-gray-600 text-lg">학원 규모와 목표에 맞는 최적의 플랜을 선택하세요</p>
          </div>

          <div className="max-w-3xl mx-auto mb-12 bg-gradient-to-r from-violet-100 to-purple-100 rounded-2xl p-6 text-center border-2 border-violet-200">
            <p className="text-lg font-semibold text-gray-800">
              * 모든 플랜의 초기 세팅 비용은 <span className="text-violet-600">150,000원 (VAT 별도)</span>
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {/* Standard Plan */}
            <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold mb-2">STANDARD</h3>
                <div className="text-4xl font-bold text-violet-600 mb-2">300,000원</div>
                <p className="text-sm text-gray-500">(VAT 별도)</p>
                <p className="text-gray-600 mt-4 font-medium">"필요한 핵심만 담은 실속형 패키지"</p>
              </div>

              <ul className="space-y-3 mb-8">
                {[
                  "블로그 포스팅 6회",
                  "글자수 1500자 내외",
                  "썸네일, 디자인, 포스터 통합 제공 3회",
                  "배너 디자인(PC·모바일) + 위젯",
                  "수정 2회",
                  "블로그 SEO 세팅",
                  "어뷰징 방지 관리(IP/디지털지문)",
                  "주간 및 월간 리포트 제공"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <i className="ri-check-line text-violet-600 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-violet-50 rounded-xl p-4 mb-6">
                <p className="text-sm font-semibold text-gray-800 mb-2">추천 대상</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• 소규모 학원</li>
                  <li>• 마케팅을 처음 도입하는 학원</li>
                  <li>• 비용 대비 효율 중시 원장님</li>
                </ul>
              </div>

              <button className="w-full bg-violet-600 text-white py-4 rounded-xl font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap cursor-pointer">
                상담 신청하기
              </button>
            </div>

            {/* Deluxe Plan - BEST */}
            <div className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-violet-500 relative transform md:scale-105">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-violet-500 to-purple-500 text-white px-6 py-2 rounded-full font-bold text-sm whitespace-nowrap">
                BEST 추천
              </div>

              <div className="text-center mb-6 mt-4">
                <h3 className="text-2xl font-bold mb-2">DELUXE</h3>
                <div className="text-4xl font-bold text-violet-600 mb-2">550,000원</div>
                <p className="text-sm text-gray-500">(VAT 별도)</p>
                <p className="text-gray-600 mt-4 font-medium">"블로그 + 인스타 동시 운영으로 성장 속도를 높이는 확장형 패키지"</p>
              </div>

              <ul className="space-y-3 mb-8">
                {[
                  "블로그 포스팅 6회",
                  { text: "인스타 피드 및 릴스 제작 4회", bold: true },
                  "글자수 1500자 내외",
                  "썸네일, 디자인, 포스터 통합 제공 5회",
                  "배너 디자인(PC·모바일) + 위젯",
                  "수정 5회",
                  "SEO 세팅",
                  "어뷰징 방지(IP/디지털지문)",
                  "주간 및 월간 리포트 제공",
                  "맞춤 콘텐츠 기획안 월 1회(학원 커리큘럼 기반)"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <i className="ri-check-line text-violet-600 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className={`text-gray-700 ${typeof item === 'object' && item.bold ? 'font-semibold' : ''}`}>
                      {typeof item === 'object' ? item.text : item}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="bg-violet-50 rounded-xl p-4 mb-6">
                <p className="text-sm font-semibold text-gray-800 mb-2">추천 대상</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• SNS와 블로그 병행 노출이 필요한 학원</li>
                  <li>• 상담 증가·브랜딩이 필요한 학원</li>
                  <li>• 학부모 신뢰도 강화가 필요한 학원</li>
                </ul>
              </div>

              <button className="w-full bg-gradient-to-r from-violet-600 to-purple-600 text-white py-4 rounded-xl font-semibold hover:from-violet-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer">
                상담 신청하기
              </button>
            </div>

            {/* Premium Plan */}
            <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold mb-2">PREMIUM</h3>
                <div className="text-4xl font-bold text-violet-600 mb-2">700,000원</div>
                <p className="text-sm text-gray-500">(VAT 별도)</p>
                <p className="text-gray-600 mt-4 font-medium">"운영·데이터·전략까지 함께 설계하는 프리미엄 성장 패키지"</p>
              </div>

              <ul className="space-y-3 mb-8">
                {[
                  "블로그 포스팅 8회",
                  { text: "인스타 피드 및 릴스 제작 6회", bold: true },
                  "글자수 1500자 내외",
                  "썸네일, 디자인, 포스터 통합 제공 8회",
                  "배너 디자인 + 위젯",
                  "수정 10회",
                  "고급 SEO 구조 설계",
                  "어뷰징 방지 관리",
                  "주간 및 월간 리포트 제공",
                  "경쟁 학원 분석 리포트 월 1회",
                  "운영 데이터 기반 콘텐츠 전략 수립",
                  "월 1회 정기 미팅(온라인/오프라인 선택)",
                  "학부모 대상 리마케팅용 카피라이팅 제공(메시지/문자 발송용)",
                  "긴급 포스팅 2회 제공 (당일 제작)",
                  "학원 행사/설명회 포스터 월 1회 무료 제작"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <i className="ri-check-line text-violet-600 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className={`text-gray-700 ${typeof item === 'object' && item.bold ? 'font-semibold' : ''}`}>
                      {typeof item === 'object' ? item.text : item}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="bg-violet-50 rounded-xl p-4 mb-6">
                <p className="text-sm font-semibold text-gray-800 mb-2">추천 대상</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• 경쟁이 치열한 지역 학원</li>
                  <li>• 장기적인 브랜딩 + 실전 상담 증가 목표</li>
                  <li>• 마케팅 전략 및 운영 분석을 함께 받고 싶은 학원</li>
                </ul>
              </div>

              <button className="w-full bg-violet-600 text-white py-4 rounded-xl font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap cursor-pointer">
                상담 신청하기
              </button>
            </div>
          </div>

          <div className="text-center bg-gradient-to-r from-violet-100 to-purple-100 rounded-2xl p-8 border-2 border-violet-200">
            <p className="text-lg text-gray-700 mb-4">
              <span className="font-bold text-violet-600">어떤 플랜이 맞을지 고민되시나요?</span>
            </p>
            <p className="text-gray-600 mb-6">
              학원 규모와 목표에 맞는 최적의 플랜을 무료로 상담해드립니다.
            </p>
            <button className="bg-gradient-to-r from-violet-600 to-purple-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-violet-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer">
              무료 상담 신청하기
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gradient-to-br from-violet-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-violet-600">블룸업</span>의 전문 서비스
            </h3>
            <p className="text-xl text-gray-600">학원 성장을 위한 맞춤형 마케팅 솔루션</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-gradient-to-br from-violet-500 to-purple-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-article-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">블로그 운영 대행</h4>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    학원의 전문성과 신뢰성을 보여주는 고품질 블로그 콘텐츠를 제작하고 운영합니다.
                    SEO 최적화를 통해 검색 노출을 높이고 잠재 고객을 유치합니다.
                  </p>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>전문적인 교육 콘텐츠 제작</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>SEO 최적화 및 검색 노출 향상</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>정기적인 포스팅 및 관리</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-gradient-to-br from-violet-500 to-purple-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">인스타그램 마케팅</h4>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    학원의 일상과 성과를 시각적으로 매력적인 콘텐츠로 제작하여
                    젊은 학부모들과의 소통을 강화하고 브랜드 인지도를 높입니다.
                  </p>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>매력적인 비주얼 콘텐츠 제작</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>스토리 및 릴스 활용 전략</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>팔로워 증가 및 참여도 향상</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-gradient-to-br from-violet-500 to-purple-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">브랜딩 컨설팅</h4>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    학원만의 고유한 브랜드 아이덴티티를 구축하고, 학부모들에게 신뢰감 있는
                    이미지를 전달하는 전략적 브랜딩 컨설팅을 제공합니다.
                  </p>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>학원 브랜드 아이덴티티 구축</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>차별화 포인트 발굴 및 강조</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>신뢰감 있는 이미지 전략 수립</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-gradient-to-br from-violet-500 to-purple-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-line-chart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-4">마케팅 전략 수립</h4>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    학원의 목표와 현황을 분석하여 맞춤형 마케팅 전략을 수립하고
                    체계적인 실행 계획을 통해 확실한 성과를 창출합니다.
                  </p>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>시장 분석 및 경쟁사 조사</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>타겟 고객 분석</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-violet-500"></i>
                      <span>성과 측정 및 개선</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                <span className="text-violet-600">블룸업</span> 마케팅 전문 회사
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                마케팅 분야에서 쌓은 풍부한 경험과 노하우를 바탕으로
                학원 전문 마케팅 서비스를 제공하고 있습니다.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center">
                    <i className="ri-user-line text-violet-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">대표: 김초롱</h4>
                    <p className="text-gray-600">마케팅 전문가</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center">
                    <i className="ri-building-line text-violet-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">사업자번호</h4>
                    <p className="text-gray-600">102-20-08696</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-violet-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">연락처</h4>
                    <p className="text-gray-600">010.4963.0538</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-violet-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">이메일</h4>
                    <p className="text-gray-600">bloomup.kim@gmail.com</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-violet-500 to-purple-500 p-6 rounded-xl">
                <h4 className="font-bold text-white mb-3">블룸업의 약속</h4>
                <p className="text-violet-100 leading-relaxed">
                  "학원의 성장이 곧 우리의 성공입니다. 단순한 마케팅 대행이 아닌,
                  진정한 파트너로서 함께 성장하겠습니다."
                </p>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://static.readdy.ai/image/bc4e4690aacf4388805038e3c17a45ec/dfc7f4cfd060c8ca17d7b139beb59eb9.jpeg"
                alt="김초롱 대표"
                className="w-full rounded-2xl shadow-2xl object-cover"
              />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gradient-to-br from-violet-500 to-purple-500 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-3xl text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              무료 상담 신청
            </h3>
            <p className="text-xl text-gray-600">
              학원 마케팅에 대한 고민, 부담 없이 상담받아보세요
            </p>
          </div>

          <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8">
            <form
              id="consultation-form"
              data-readdy-form
              action="https://readdy.ai/api/form/d4aanfs8ldqdu8nb3v6g"
              method="POST"
              className="space-y-6"
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    이름 *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent text-sm"
                    placeholder="이름을 입력해주세요"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    연락처 *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent text-sm"
                    placeholder="010-0000-0000"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="academy_name" className="block text-sm font-medium text-gray-700 mb-2">
                  학원명 *
                </label>
                <input
                  type="text"
                  id="academy_name"
                  name="academy_name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent text-sm"
                  placeholder="학원명을 입력해주세요"
                />
              </div>

              <div>
                <label htmlFor="academy_type" className="block text-sm font-medium text-gray-700 mb-2">
                  학원 유형 *
                </label>
                <select
                  id="academy_type"
                  name="academy_type"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">학원 유형을 선택해주세요</option>
                  <option value="수학">수학학원</option>
                  <option value="영어">영어학원</option>
                  <option value="국어">국어학원</option>
                  <option value="과학">과학학원</option>
                  <option value="미술">미술학원</option>
                  <option value="음악">음악학원</option>
                  <option value="체육">체육학원</option>
                  <option value="종합">종합학원</option>
                  <option value="기타">기타</option>
                </select>
              </div>

              <div>
                <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-2">
                  학원 위치 *
                </label>
                <input
                  type="text"
                  id="location"
                  name="location"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent text-sm"
                  placeholder="예: 서울시 강남구"
                />
              </div>

              <div>
                <label htmlFor="inquiry_type" className="block text-sm font-medium text-gray-700 mb-2">
                  관심 서비스 *
                </label>
                <div className="grid grid-cols-2 gap-3">
                  <label className="flex items-center cursor-pointer">
                    <input type="checkbox" name="inquiry_type" value="블로그 운영" className="mr-2 accent-violet-500" />
                    <span className="text-sm">블로그 운영</span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input type="checkbox" name="inquiry_type" value="인스타그램 마케팅" className="mr-2 accent-violet-500" />
                    <span className="text-sm">인스타그램 마케팅</span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input type="checkbox" name="inquiry_type" value="브랜딩 컨설팅" className="mr-2 accent-violet-500" />
                    <span className="text-sm">브랜딩 컨설팅</span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input type="checkbox" name="inquiry_type" value="마케팅 전략" className="mr-2 accent-violet-500" />
                    <span className="text-sm">마케팅 전략</span>
                  </label>
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  문의 내용
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent text-sm resize-none"
                  placeholder="궁금한 점이나 요청사항을 자유롭게 작성해주세요 (최대 500자)"
                ></textarea>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="bg-violet-500 hover:bg-violet-600 text-white px-12 py-4 rounded-full text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  무료 상담 신청하기
                </button>
              </div>
            </form>
          </div>

          <div className="mt-12 text-center">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-violet-50 to-purple-50 p-6 rounded-xl">
                <div className="w-12 h-12 bg-violet-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">전화 상담</h4>
                <p className="text-gray-600 mb-3">빠른 상담을 원하시면 전화로 연락주세요</p>
                <a href="tel:010-4963-0538" className="text-violet-600 font-semibold cursor-pointer">
                  010.4963.0538
                </a>
              </div>

              <div className="bg-gradient-to-br from-violet-50 to-purple-50 p-6 rounded-xl">
                <div className="w-12 h-12 bg-violet-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">이메일 상담</h4>
                <p className="text-gray-600 mb-3">자세한 문의는 이메일로 보내주세요</p>
                <a href="mailto:bloomup.kim@gmail.com" className="text-violet-600 font-semibold cursor-pointer">
                  bloomup.kim@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-violet-950 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-2xl font-bold mb-4 text-violet-300" style={{ fontFamily: '"Pacifico", serif' }}>
                블룸업
              </h4>
              <p className="text-violet-200 mb-4">
                학원 전문 블로그 운영 및 인스타그램 마케팅
              </p>
              <p className="text-violet-300 text-sm">
                학원의 성장이 곧 우리의 성공입니다
              </p>
            </div>

            <div>
              <h5 className="font-bold mb-4 text-violet-200">회사 정보</h5>
              <div className="space-y-2 text-violet-300">
                <p>대표: 김초롱</p>
                <p>사업자번호: 102-20-08696</p>
              </div>
            </div>

            <div>
              <h5 className="font-bold mb-4 text-violet-200">연락처</h5>
              <div className="space-y-2 text-violet-300">
                <p>전화: 010.4963.0538</p>
                <p>이메일: bloomup.kim@gmail.com</p>
              </div>
            </div>
          </div>

          <div className="border-t border-violet-800 mt-8 pt-8 text-center">
            <p className="text-violet-400">
              © 2024 블룸업. All rights reserved. |
              <a href="https://readdy.ai/?origin=logo" className="text-violet-300 hover:text-violet-200 ml-1 cursor-pointer">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
